import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { RELEASE_HIGHLIGHTS_CONFIG } from '../../config/release-highlights.config';
import { ReleaseHighlight } from '../../interfaces/release-highlight.interface';

@Component({
    selector: 'app-release-highlights-modal',
    templateUrl: './release-highlights-modal.component.html',
    styleUrls: ['./release-highlights-modal.component.scss'],
})
export class ReleaseHighlightsModalComponent implements OnInit, OnDestroy {
    private readonly ngDestroy = new Subject<void>();
    @Output() closeModal = new EventEmitter<void>();

    slides: ReleaseHighlight[] = RELEASE_HIGHLIGHTS_CONFIG.highlights;
    currentSlide = 0;
    showModal = true;

    constructor() { }

    ngOnInit(): void { }

    onImageError(event: Event): void {
        const element = event.target as HTMLImageElement;
        element.style.display = 'none';
    }

    ngOnDestroy(): void {
        this.ngDestroy.next();
        this.ngDestroy.complete();
    }

    nextSlide(): void {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
        }
    }

    previousSlide(): void {
        if (this.currentSlide > 0) {
            this.currentSlide--;
        }
    }

    close(): void {
        this.showModal = false;
        this.closeModal.emit();
    }
}
